import { createTheme } from "@mui/material/styles";

// Create a custom theme mimicking Otter.ai's color scheme
const otterTheme = createTheme({
  palette: {
    mode: "light", // Switch to light mode
    primary: {
      main: "#1976d2", // Light blue (Otter uses blues prominently)
    },
    secondary: {
      main: "#555555", // Neutral gray for secondary elements
    },
    background: {
      default: "#ffffff", // White background for a clean layout
      paper: "#f4f6f8", // Light gray for card and paper surfaces
    },
    text: {
      primary: "#333333", // Darker text color for readability
      secondary: "#666666", // Lighter gray for secondary text
    },
  },
  typography: {
    fontFamily: "'Averta', Arial, sans-serif", // Apply the Averta font family globally
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "25px", // Apply rounded corners globally
          padding: "8px 16px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          padding: "8px 16px",
          color: "#333333", // Darker color for contrast with the background
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.1)", // Light blue hover effect (Otter-like hover)
          },
          "&:focus": {
            backgroundColor: "rgba(25, 118, 210, 0.2)", // Slightly stronger focus effect
          },
        },
      },
    },
  },
});

export default otterTheme;
